import React from 'react';
import StockLocationNotification from './StockLocation/stockLocationNotification';
import BinStatusNotification from './BinStatus/binStatusNotification';
import BinNotification from './Bin/binNotification';
import ProductMasterDataNotification from './ProductMasterData/productMasterDataNotification';
import ProductNotification from './Product/productNotification';
import TaskNotification from './Task/taskNotification';
import CommentNotification from './Comment/commentNotification';
import ContactNotification from './Contact/contactNotification';
import AlertNotification from './Alerts/alertNotification';
import OrderNotification from './Order/orderNotification';
import ProductTransactionNotification from './ProductTransaction/productTransactionNotification';
import ContainerNotification from './Container/containerNotification';
import AssetNotification from './Asset/assetNotification';
import AssetTransactionNotification from './AssetTransaction/assetTransactionNotification';
import LotNotification from './Lot/lotNotification';
import TriggerNotification from './Trigger/triggerNotification';
import CompanyConnectionNotification from './CompanyConneciton/companyConnectionNotification';
import IntegrationSettingsNotification from './IntegrationSettings/integrationSettingsNotification';
import KitNotification from './Kit/kitNotification';
import FileNotification from './File/fileNotification';

interface NotificationHandlerProps {}

export default function NotificationHandler({}: NotificationHandlerProps) {
  return (
    <>
      <BinStatusNotification />
      <ProductMasterDataNotification />
      <StockLocationNotification />
      <BinNotification />
      <FileNotification />
      <ProductNotification />
      <TaskNotification />
      <CommentNotification />
      <ContactNotification />
      <OrderNotification />
      <ProductTransactionNotification />
      <AlertNotification />
      <ContainerNotification />
      <LotNotification />
      <AssetNotification />
      <AssetTransactionNotification />
      <LotNotification />
      <TriggerNotification />
      <IntegrationSettingsNotification />
      <CompanyConnectionNotification />
      <KitNotification />
    </>
  );
}
